module.exports = __webpack_public_path__ + "img/header-weddingRingsSlim.bbedb4a.jpg";